export const calculateLegacySlabTax = (amount) => {
  const amt = parseFloat(amount) || 0;
  if (amt <= 50) return 0;
  if (amt > 500) {
    return Math.round(450 * 0.12 + (amt - 500) * 0.2);
  }
  return Math.round((amt - 50) * 0.12);
};

export const normalizeTaxPositionKey = (position = "") => {
  const norm = String(position).trim().toLowerCase().replace(/[\s\-_/]+/g, "");
  if (norm === "dealer" || norm.includes("dealer")) return "dealer";
  if (norm.includes("waitress") || norm.includes("server") || norm.includes("waiter")) return "waitress";
  if (norm.includes("floor") || norm.includes("supervisor")) return "floorsupervisor";
  if (norm === "bartender" || norm.includes("bartender") || norm.includes("bar")) return "bartender";
  if (norm === "host" || norm === "hosts") return "host";
  if (norm === "cashier" || norm.includes("cashier")) return "cashier";
  if (norm.includes("janitor") || norm.includes("custodian") || norm.includes("cleaner")) return "janitor";
  if (norm === "cook" || norm === "cooks") return "cook";
  return "other";
};

export const findTaxSettingForPosition = (settings = [], position = "") => {
  const normKey = normalizeTaxPositionKey(position);
  if (Array.isArray(settings)) {
    const found = settings.find(
      (s) => normalizeTaxPositionKey(s.position_key) === normKey
    );
    if (found) return found;

    const otherFound = settings.find(
      (s) => normalizeTaxPositionKey(s.position_key) === "other"
    );
    if (otherFound) {
      return otherFound;
    }
  }
  return {
    position_key: "other",
    position_name: "Other Positions",
    rate_percentage: 0,
    tax_type: "exempt",
    is_active: true
  };
};

/**
 * Calculates dynamic tax based on loaded tax management settings.
 */
export const calculateDynamicTax = (
  amount,
  position = "",
  settings = [],
  transactionDate = new Date()
) => {
  const amt = parseFloat(amount) || 0;
  if (amt <= 0) {
    return {
      tax: 0,
      paidOut: 0,
      ratePercentage: 0,
      taxType: 'exempt',
      label: 'Tax (0%)'
    };
  }

  const setting = findTaxSettingForPosition(settings, position);

  if (!setting.is_active || setting.tax_type === 'exempt') {
    return {
      tax: 0,
      paidOut: amt,
      ratePercentage: 0,
      taxType: 'exempt',
      label: 'Tax (0%)'
    };
  }

  if (setting.tax_type === 'slab') {
    const slabTax = calculateLegacySlabTax(amt);
    return {
      tax: slabTax,
      paidOut: amt - slabTax,
      ratePercentage: 0,
      taxType: 'slab',
      label: 'Tax (slab)'
    };
  }

  const rate = parseFloat(setting.rate_percentage) || 0;
  if (rate <= 0) {
    return {
      tax: 0,
      paidOut: amt,
      ratePercentage: 0,
      taxType: 'exempt',
      label: 'Tax (0%)'
    };
  }

  const tax = Math.round(amt * (rate / 100));
  const rateLabel = Number.isInteger(rate) ? `${rate}%` : `${rate.toFixed(1)}%`;

  return {
    tax,
    paidOut: amt - tax,
    ratePercentage: rate,
    taxType: 'percentage',
    label: `Tax (${rateLabel})`
  };
};

/**
 * Returns formatted rate label for a position.
 */
export const getDynamicTaxRateLabel = (
  position = "",
  settings = [],
  transactionDate = new Date()
) => {
  const setting = findTaxSettingForPosition(settings, position);
  if (!setting || !setting.is_active || setting.tax_type === 'exempt') {
    return "Tax (0%)";
  }
  if (setting.tax_type === 'slab') {
    return "Tax (slab)";
  }
  const rate = parseFloat(setting.rate_percentage) || 0;
  const rateLabel = Number.isInteger(rate) ? `${rate}%` : `${rate.toFixed(1)}%`;
  return `Tax (${rateLabel})`;
};
